module.exports = __webpack_public_path__ + "static/media/carPhoto5.1db85190.jpeg";